import React from 'react'
import { Form, Switch } from 'antd'

/** The standard "Active" switch shown on the review step of every mapping form. */
export const ActiveField = () => (
  <Form.Item
    label="Active"
    name="active"
    valuePropName="checked"
    help="Used by the sync immediately on save."
  >
    <Switch />
  </Form.Item>
)
